import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { zindex } from 'src/ui/zindex';

export const StyledFeedbackButton = styled(PrimaryButton)`
  z-index: ${zindex.menu.sticky.background.default + 1};
  transform-origin: 100% 100%;
  visibility: ${ifProp('hidden', 'hidden', 'visible')};

  position: fixed;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  transform: rotate(-90deg) translateX(50%);
  right: 0;
  bottom: 50%;
`;
